var util = require('service/util');
    var appController = require('service/app-controller');

    module.exports = {
        props:{
            file:Object,
            select:Function,
            dragstart:Function
        },
        data: function () {
            return {
                dragging:false
            }
        },
        methods: {
            onDragstart:function ($event,file) {
                this.dragstart($event,file);
                this.dragging = true;
            },
            onDragend:function () {
                this.dragging = false;
            },
            mousedownOnFileItem:function (e) {
                if ( $(e.target).is('.file-item') && e.button==0 ){
                    $event.emit('mousedown:wallpaper',{x:e.clientX,y:e.clientY})
                }else if(e.button==0){
                    $event.emit('mousedown:file',{x:e.clientX,y:e.clientY});
                }
            },
            contextmenuOnFileItem:function (e,file) {
                if ( $(e.target).is('.file-item') ){
                    $event.emit('contextmenu:wallpaper',{x:e.clientX,y:e.clientY})
                }else{
                    $event.emit('contextmenu:file',{x:e.clientX,y:e.clientY,file:file})
                }
            }
        },
        components: {},
        ready: function () {

        }
    }


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/file-item.vue
 ** module id = 51
 ** module chunks = 0
 **/